import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';


import { CardComponent } from './components';


@NgModule({
  imports: [
    RouterModule,
  ],
  declarations: [
    CardComponent,
  ],
  exports: [
    CardComponent,
  ],
})
export class CardModule {}
